// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__7OpRd","main":"NotFound_main__v5Rtm","subtitle":"NotFound_subtitle__emmiH","login-btn-div":"NotFound_login-btn-div__TIL7z"};